function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _ from "underscore";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import AdvancedComboboxContent from "./advanced-combobox-content";
import Loading from "../elements/loading";

var OrgPicker = function OrgPicker(props) {
  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      searchText = _useState2[0],
      setSearchText = _useState2[1];

  var _useState3 = useState(props.orgs),
      _useState4 = _slicedToArray(_useState3, 2),
      searchResults = _useState4[0],
      setSearchResults = _useState4[1];

  useEffect(function () {
    if (searchText !== "") {
      var results = props.orgs.filter(function (org) {
        return org.label.toLowerCase().includes(searchText.toLowerCase()) || org.value.toString().toLowerCase().includes(searchText) || org.slug.toLowerCase().includes(searchText.toLowerCase());
      });
      setSearchResults(results);
    } else {
      setSearchResults(props.orgs);
    }
  }, [props.orgs, searchText]);
  return /*#__PURE__*/React.createElement("div", {
    className: "org-picker"
  }, props.loading ? /*#__PURE__*/React.createElement(Loading, null) : null, _.isEmpty(props.orgs) ? /*#__PURE__*/React.createElement("div", {
    className: "org-picker--empty"
  }, "You do not have access to any EverTrue organizations.") : /*#__PURE__*/React.createElement("div", {
    className: "org-picker--full-height"
  }, /*#__PURE__*/React.createElement("div", {
    className: "org-picker--header"
  }, "Select an Organization"), /*#__PURE__*/React.createElement("div", {
    className: "org-picker--body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "org-picker--selector"
  }, /*#__PURE__*/React.createElement(AdvancedComboboxContent, {
    options: searchResults,
    onSearch: function onSearch(searchText) {
      setSearchText(searchText);
    },
    searchable: true,
    focusOnMount: true,
    onChange: function onChange(val) {
      return props.handleChange(val);
    }
  })))));
};

OrgPicker.propTypes = {
  orgs: PropTypes.array,
  loading: PropTypes.bool,
  handleChange: PropTypes.func
};
export default OrgPicker;